export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-rocket-2-line',
      title: 'LaunchPage',
      description: 'High-converting single pages designed to capture leads and drive action.',
      features: [
        'Conversion-optimized design',
        'A/B testing ready',
        'Mobile-first approach',
        'Fast loading times'
      ]
    },
    {
      icon: 'ri-palette-line',
      title: 'The Growth Site',
      description: 'Beautiful, user-friendly websites that reflect your brand and engage your audience.',
      features: ['Custom Design', 'Brand Integration', 'User Experience', 'Visual Appeal']
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Web Development',
      description: 'Custom web applications and dynamic websites built with modern technologies and best practices.',
      features: [
        'Modern Frameworks',
        'Scalable Architecture',
        'API Integration',
        'Performance Optimization'
      ]
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'E-commerce Development',
      description: 'Complete online stores with secure payment processing and inventory management.',
      features: ['Payment Integration', 'Product Management', 'Order Processing', 'Analytics']
    },
    {
      icon: 'ri-brain-line',
      title: 'AI-Powered Software Development',
      description: `We turn ideas into real software using AI.
Custom apps, automations, and digital products built in weeks, not months, combining artificial intelligence with tech expertise.`,
      features: [
        'Custom applications',
        'AI automations',
        'Smart workflows',
        'Scalable systems',
        'Production-ready delivery'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            What We <span className="text-[#D96B33]">Offer</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Comprehensive web development solutions tailored to your business needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-[#EBEBE0] p-8 rounded-3xl hover:bg-white hover:shadow-2xl transition-all duration-500 cursor-pointer hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#D96B33] to-[#B85A2B] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {service.title}
              </h3>
              
              <p className="text-[#2E3F25] mb-6 leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center gap-3 text-[#2E3F25]" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                    <i className="ri-check-line text-[#D96B33] text-lg"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}